var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSlogan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 275.687,
    height: 78.87,
    viewBox: "0 0 275.687 78.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.492,
    y1: 0.699,
    x2: 0.503,
    y2: -0.023,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92cdc2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.668,
    y1: 0.237,
    x2: 0.388,
    y2: 0.936,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e84671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad1f4e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: -0.765,
    x2: 0.5,
    y2: 0.566,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#020202",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: -0.262,
    x2: 0.5,
    y2: 0.689,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    y1: -0.042,
    x2: 0.5,
    y2: 0.532,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.5,
    y1: 0.006,
    x2: 0.5,
    y2: 0.752,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    y1: -0.443,
    x2: 0.5,
    y2: 1.778,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.5,
    y1: 0.016,
    x2: 0.5,
    y2: 0.777,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.5,
    y1: -0.032,
    x2: 0.5,
    y2: 0.766,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.5,
    y1: 0.011,
    x2: 0.5,
    y2: 1.281,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.5,
    y1: 0.015,
    x2: 0.5,
    y2: 0.776,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.5,
    y1: -0.164,
    x2: 0.5,
    y2: 0.714,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.5,
    y1: -0.259,
    x2: 0.5,
    y2: 0.692,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.5,
    y1: -0.445,
    x2: 0.5,
    y2: 0.639,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.5,
    y1: -1.449,
    x2: 0.5,
    y2: 0.444,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.5,
    y1: -6.471,
    x2: 0.5,
    y2: -0.697,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.49,
    y1: -883.59,
    x2: 0.49,
    y2: -51.485,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_199",
    "data-name": "Grupo 199",
    transform: "translate(-558 -32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_142",
    "data-name": "Grupo 142",
    transform: "translate(558 32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1616",
    "data-name": "Trazado 1616",
    d: "M452.718,443.676l-11.272-.115a20.447,20.447,0,0,0-5.59-12.041l5.571-3.32a.677.677,0,0,0-.39-1.258l-10.337.66a20.425,20.425,0,0,0-9.665-2.417H387.181a20.523,20.523,0,0,0-20.523,20.523v32.48A20.425,20.425,0,0,0,370.6,490.28L359.04,502.655a.829.829,0,0,0,.916,1.335l18.235-7.35a20.441,20.441,0,0,0,8.989,2.071h33.854a20.523,20.523,0,0,0,20.523-20.523V452.926l11.619-7.7A.846.846,0,0,0,452.718,443.676Z",
    transform: "translate(-358.811 -425.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1617",
    "data-name": "Trazado 1617",
    d: "M452.7,431.941S409.485,444.859,394.84,464.9c0,0,13.519,2.365,17.331,3.419a68.572,68.572,0,0,0-23.52,16.385,2.381,2.381,0,0,1-.369.32,3.069,3.069,0,0,1-4.7-2.64V449.9a19.158,19.158,0,0,1,19.092-18.339l29.155-.074-7.792,5.488S431.9,434.062,452.7,431.941Z",
    transform: "translate(-372.846 -428.756)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1618",
    "data-name": "Trazado 1618",
    d: "M456.116,470.891S432.432,473.526,421,482.079c0,0,14.245,2.008,19.957,5.282,0,0-45.481,10.877-72.552,39.738a80.025,80.025,0,0,1,22.677-10.7L388,518.717a1.508,1.508,0,0,0,.907,2.712l36.426.032A19.538,19.538,0,0,0,444.1,501.97V477.289Z",
    transform: "translate(-364.245 -451.081)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1619",
    "data-name": "Trazado 1619",
    d: "M524.872,470.891s-24.916,7.6-28.318,12.449l-6.8-1.261S499.031,473.581,524.872,470.891Z",
    transform: "translate(-433.001 -451.081)",
    fill: "#ad1f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1620",
    "data-name": "Trazado 1620",
    d: "M433.961,513.149s1.354-1.146,5.688,1.547c0,0-53.944,20.054-71.247,36.208C368.4,550.9,390.833,525.854,433.961,513.149Z",
    transform: "translate(-364.245 -474.887)",
    fill: "#ad1f4e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_144",
    "data-name": "Grupo 144",
    transform: "translate(653 56.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1621",
    "data-name": "Trazado 1621",
    d: "M577.872,504.579l3.221-3.858a11.365,11.365,0,0,0,7.4,3.009c2.23,0,3.576-.885,3.576-2.336v-.071c0-1.38-.85-2.089-4.992-3.151-4.991-1.274-8.212-2.655-8.212-7.575v-.071c0-4.5,3.611-7.469,8.673-7.469a14.342,14.342,0,0,1,9.2,3.15l-2.832,4.106a11.623,11.623,0,0,0-6.442-2.442c-2.089,0-3.186.956-3.186,2.159v.071c0,1.628,1.062,2.159,5.346,3.256,5.026,1.31,7.858,3.116,7.858,7.433v.071c0,4.92-3.752,7.682-9.1,7.682A15.766,15.766,0,0,1,577.872,504.579Z",
    transform: "translate(-577.872 -482.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1622",
    "data-name": "Trazado 1622",
    d: "M617.926,507.611V495.327h5.381v10.584c0,2.549,1.2,3.858,3.256,3.858s3.362-1.31,3.362-3.858V495.327h5.381V514.3h-5.381v-2.69a6.712,6.712,0,0,1-5.558,3.044C620.3,514.655,617.926,511.964,617.926,507.611Z",
    transform: "translate(-597.822 -488.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1623",
    "data-name": "Trazado 1623",
    d: "M655.087,494.976h5.381V497.7a6.967,6.967,0,0,1,5.912-3.08c4.424,0,8.637,3.469,8.637,9.805v.071c0,6.336-4.141,9.805-8.637,9.805a7.286,7.286,0,0,1-5.912-2.832v8.141h-5.381Zm14.549,9.523v-.071c0-3.151-2.124-5.239-4.637-5.239s-4.6,2.089-4.6,5.239v.071c0,3.15,2.089,5.239,4.6,5.239S669.636,507.685,669.636,504.5Z",
    transform: "translate(-616.331 -488.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1624",
    "data-name": "Trazado 1624",
    d: "M693.8,504.569v-.07c0-5.416,3.859-9.876,9.38-9.876,6.336,0,9.239,4.92,9.239,10.3,0,.425-.036.92-.071,1.416h-13.2a4.4,4.4,0,0,0,4.637,3.716,6.216,6.216,0,0,0,4.6-1.947l3.08,2.725a10.022,10.022,0,0,1-17.664-6.266Zm13.381-1.592c-.319-2.408-1.735-4.036-4-4.036-2.229,0-3.682,1.593-4.106,4.036Z",
    transform: "translate(-635.612 -488.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1625",
    "data-name": "Trazado 1625",
    d: "M731.807,494.968h5.381v3.823c1.1-2.619,2.867-4.319,6.053-4.177v5.628h-.283c-3.575,0-5.77,2.16-5.77,6.691v7.009h-5.381Z",
    transform: "translate(-654.543 -488.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1626",
    "data-name": "Trazado 1626",
    d: "M756.938,483.761H762.6l3.575,10.478,9.238-10.478h6.3l-6.655,24.779h-5.522l4.318-16.177-9.7,10.584h-.141l-3.964-10.478-4.319,16.071h-5.451Z",
    transform: "translate(-663.746 -482.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1627",
    "data-name": "Trazado 1627",
    d: "M805.5,509.346c0-4.389,3.575-6.832,8.177-6.832a17.445,17.445,0,0,1,5.345.85l.071-.247a5.419,5.419,0,0,0,.212-1.416c0-1.31-.92-2.23-3.575-2.23a13.847,13.847,0,0,0-5.062,1.026l-.849-4.247a18.355,18.355,0,0,1,7.044-1.346c5.1,0,7.681,2.124,7.681,5.841a11.231,11.231,0,0,1-.425,2.867l-2.8,10.478h-5.2l.567-2.2a7.577,7.577,0,0,1-5.664,2.549C807.727,514.444,805.5,512.32,805.5,509.346Zm12.6-2.407.142-.5a10.33,10.33,0,0,0-3.54-.673c-2.23,0-3.858,1.133-3.858,2.973,0,1.169.956,2.018,2.478,2.018A5.255,5.255,0,0,0,818.1,506.939Z",
    transform: "translate(-691.246 -488.249)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1628",
    "data-name": "Trazado 1628",
    d: "M844,506.09a9.642,9.642,0,0,1,.354-2.372l2.3-8.6h-2.265l1.239-4.6h2.266l1.31-4.849h5.38l-1.31,4.849h4.46l-1.239,4.6h-4.461l-2.124,7.964a4.248,4.248,0,0,0-.142.85c0,.708.46,1.133,1.452,1.133a7.212,7.212,0,0,0,2.761-.6l-1.239,4.566a9.431,9.431,0,0,1-3.894.779C845.591,509.807,844,508.179,844,506.09Z",
    transform: "translate(-710.423 -483.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1629",
    "data-name": "Trazado 1629",
    d: "M866,505.808a11.255,11.255,0,0,1,11.186-11.185c4.177,0,6.477,1.911,7.787,4.177l-4.106,2.9a4.492,4.492,0,0,0-4.106-2.478c-2.831,0-5.451,3.079-5.451,6.584a3.706,3.706,0,0,0,3.717,4,6.282,6.282,0,0,0,4.284-1.876l2.761,3.5a9.992,9.992,0,0,1-7.221,2.938C869.68,514.374,866,510.977,866,505.808Z",
    transform: "translate(-721.381 -488.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1630",
    "data-name": "Trazado 1630",
    d: "M903.54,481.646h5.381l-2.337,8.849a7.824,7.824,0,0,1,5.168-2.336c3.4,0,5.593,2.088,5.593,5.522a15.521,15.521,0,0,1-.637,3.611l-2.725,10.195H908.6l2.8-10.407a7.586,7.586,0,0,0,.248-1.7c0-1.522-.956-2.336-2.62-2.336-2.124,0-3.5,1.522-4.106,3.788l-2.868,10.655h-5.38Z",
    transform: "translate(-736.659 -481.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_143",
    "data-name": "Grupo 143",
    transform: "translate(1.662 11.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1631",
    "data-name": "Trazado 1631",
    d: "M599.133,518.01v-.071c0-.142-.011-.273-.017-.409q-2.817.644-5.426,1.34c-.191,1.254-1.492,2.008-3.548,2.008a9.723,9.723,0,0,1-2.324-.288q-3.6,1.16-6.635,2.424a15.871,15.871,0,0,0,8.853,2.678C595.381,525.692,599.133,522.931,599.133,518.01Z",
    transform: "translate(-581.183 -511.057)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1632",
    "data-name": "Trazado 1632",
    d: "M624.371,522.465a6.714,6.714,0,0,0,5.557-3.044v2.69h5.381V511.051q-2.749.39-5.381.823v1.847c0,2.548-1.31,3.858-3.362,3.858s-3.256-1.31-3.256-3.858v-.664q-2.773.541-5.381,1.128v1.235C617.929,519.774,620.3,522.465,624.371,522.465Z",
    transform: "translate(-599.485 -507.83)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1633",
    "data-name": "Trazado 1633",
    d: "M660.471,525.6v-8.141a7.287,7.287,0,0,0,5.912,2.832c3.874,0,7.478-2.582,8.4-7.35a11.024,11.024,0,0,1-.263-2.385v-.07a10.958,10.958,0,0,1,.281-2.435,10.878,10.878,0,0,0-.355-1.366q-2.918.216-5.758.475a5.7,5.7,0,0,1,.95,3.255v.071c0,3.185-2.124,5.239-4.637,5.239s-4.6-2.089-4.6-5.239v-.071a6.069,6.069,0,0,1,.492-2.447q-2.956.344-5.8.734v16.9Z",
    transform: "translate(-617.994 -505.655)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1634",
    "data-name": "Trazado 1634",
    d: "M694.562,509.536v.071a12.856,12.856,0,0,1-.234,2.455,10.086,10.086,0,0,0,17.4,3.88l-3.08-2.726a6.216,6.216,0,0,1-4.6,1.947,4.4,4.4,0,0,1-4.637-3.717h13.2c.035-.5.071-.991.071-1.415a12.684,12.684,0,0,0-1.019-5.11q-2.8.075-5.547.188a5.084,5.084,0,0,1,1.327,2.974h-8.106a5.637,5.637,0,0,1,1.169-2.7q-2.9.163-5.741.367a10.37,10.37,0,0,0-.422,1.423A12.729,12.729,0,0,1,694.562,509.536Z",
    transform: "translate(-637.538 -504.777)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1635",
    "data-name": "Trazado 1635",
    d: "M694.3,511.769a12.72,12.72,0,0,0-.217-2.364,10.958,10.958,0,0,0-.281,2.435v.07a11.026,11.026,0,0,0,.264,2.385,12.856,12.856,0,0,0,.234-2.455Z",
    transform: "translate(-637.276 -507.01)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1636",
    "data-name": "Trazado 1636",
    d: "M737.192,518.914v-7.008c0-4.531,2.194-6.691,5.77-6.691h.283v-.574q-1.078-.006-2.16-.007-4.692,0-9.273.108v14.172Z",
    transform: "translate(-656.207 -504.634)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1637",
    "data-name": "Trazado 1637",
    d: "M788.651,519.57h5.522l3.561-13.258q-2.692-.2-5.447-.361Z",
    transform: "translate(-684.518 -505.29)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1638",
    "data-name": "Trazado 1638",
    d: "M774.439,513.458h.141l7.437-8.116q-5.306-.288-10.813-.434Z",
    transform: "translate(-675.828 -504.77)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1639",
    "data-name": "Trazado 1639",
    d: "M755.737,518.934l3.809-14.172q-2.694-.063-5.43-.088l-3.83,14.26Z",
    transform: "translate(-665.409 -504.654)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1640",
    "data-name": "Trazado 1640",
    d: "M819.022,510.428a17.432,17.432,0,0,0-5.345-.85c-4.6,0-8.177,2.442-8.177,6.832,0,2.973,2.23,5.1,5.522,5.1a7.579,7.579,0,0,0,5.664-2.549l-.567,2.194h5.2l2.8-10.478c.081-.311.15-.617.211-.925q-2.479-.328-5.042-.621a6.323,6.323,0,0,1-.2,1.05ZM818.1,514a5.255,5.255,0,0,1-4.778,3.823c-1.522,0-2.478-.849-2.478-2.018,0-1.841,1.628-2.973,3.858-2.973a10.329,10.329,0,0,1,3.539.673Z",
    transform: "translate(-692.91 -506.873)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1641",
    "data-name": "Trazado 1641",
    d: "M844,518.679c0,2.089,1.593,3.717,4.85,3.717a9.423,9.423,0,0,0,3.894-.779l1.239-4.566a7.208,7.208,0,0,1-2.761.6c-.991,0-1.451-.425-1.451-1.133a4.209,4.209,0,0,1,.142-.85l1.04-3.9q-2.535-.41-5.174-.784l-1.424,5.322A9.636,9.636,0,0,0,844,518.679Z",
    transform: "translate(-712.087 -507.798)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1642",
    "data-name": "Trazado 1642",
    d: "M874.852,523.992a9.989,9.989,0,0,0,7.213-2.931l0-.013-2.756-3.5a6.278,6.278,0,0,1-4.283,1.876,3.706,3.706,0,0,1-3.717-4c0-.146.011-.291.02-.436q-2.544-.528-5.232-1.014a11.142,11.142,0,0,0-.1,1.449C866,520.594,869.683,523.992,874.852,523.992Z",
    transform: "translate(-723.044 -509.287)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1643",
    "data-name": "Trazado 1643",
    d: "M897.351,524.879l-.009.007-.666,2.506h5.38l1.123-4.172q-2.361-.808-4.979-1.565l-.855,3.217Z",
    transform: "translate(-738.322 -513.112)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1644",
    "data-name": "Trazado 1644",
    d: "M920.443,531.219h4.376c-1.181-.642-2.476-1.269-3.871-1.881Z",
    transform: "translate(-750.16 -516.938)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1645",
    "data-name": "Trazado 1645",
    d: "M898.007,528.066l0,.013.009-.007Z",
    transform: "translate(-738.983 -516.305)",
    fill: "url(#linear-gradient-17)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_198",
    "data-name": "Grupo 198",
    transform: "translate(113.818 -425.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2510",
    "data-name": "Trazado 2510",
    d: "M549.172,523.335l.713-.625a.893.893,0,0,0,.8.45.773.773,0,0,0,.588-.25c.15-.138.225-.312.387-.9l.663-2.463h1l-.713,2.7a2.48,2.48,0,0,1-.662,1.35,1.784,1.784,0,0,1-1.325.488A1.757,1.757,0,0,1,549.172,523.335Z",
    transform: "translate(0.01 -0.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2511",
    "data-name": "Trazado 2511",
    d: "M559.156,522.572a3.815,3.815,0,0,1,.087-.712l.625-2.313h.988l-.65,2.4a2.024,2.024,0,0,0-.062.5.7.7,0,0,0,.763.738,1.017,1.017,0,0,0,.75-.3,1.908,1.908,0,0,0,.425-.812l.663-2.525h1l-.725,2.663a2.9,2.9,0,0,1-.688,1.325,1.985,1.985,0,0,1-1.525.55A1.453,1.453,0,0,1,559.156,522.572Z",
    transform: "translate(-4.013 -0.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2512",
    "data-name": "Trazado 2512",
    d: "M570.313,519.547h3.338l-.225.888h-2.363l-.238.888h2.063l-.225.863h-2.075l-.25.963h2.375l-.225.85h-3.363Z",
    transform: "translate(-8.021 -0.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2513",
    "data-name": "Trazado 2513",
    d: "M579.344,522.113a2.741,2.741,0,0,1,2.775-2.675,2.213,2.213,0,0,1,1.838.763l-.75.638a1.484,1.484,0,0,0-1.175-.5,1.713,1.713,0,0,0-1.675,1.738,1.046,1.046,0,0,0,1.138,1.075,1.713,1.713,0,0,0,.8-.187l.212-.712h-1l.238-.838h1.938l-.625,2.225a3.223,3.223,0,0,1-1.625.4A1.928,1.928,0,0,1,579.344,522.113Z",
    transform: "translate(-12.125 -0.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2514",
    "data-name": "Trazado 2514",
    d: "M592.019,519.5h.95l.713,4.488h-1.025l-.138-.987h-1.888l-.662.987h-1.062Zm.388,2.638-.2-1.488-.988,1.488Z",
    transform: "translate(-15.97 -0.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2515",
    "data-name": "Trazado 2515",
    d: "M607.313,519.547h1.313a2.337,2.337,0,0,1,1.738.575,1.7,1.7,0,0,1,.488,1.3,2.428,2.428,0,0,1-.738,1.763,3.063,3.063,0,0,1-2.325.813h-1.663Zm.587,3.575a2.01,2.01,0,0,0,1.488-.55,1.506,1.506,0,0,0,.45-1.113.941.941,0,0,0-.275-.7,1.412,1.412,0,0,0-1.013-.325h-.488l-.725,2.688Z",
    transform: "translate(-22.898 -0.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2516",
    "data-name": "Trazado 2516",
    d: "M617.547,522.075a2.675,2.675,0,0,1,2.7-2.638,1.917,1.917,0,0,1,2.025,1.975,2.65,2.65,0,0,1-2.675,2.625A1.928,1.928,0,0,1,617.547,522.075Zm3.713-.612a1.05,1.05,0,0,0-1.125-1.125,1.64,1.64,0,0,0-1.55,1.675,1.05,1.05,0,0,0,1.138,1.138A1.649,1.649,0,0,0,621.26,521.463Z",
    transform: "translate(-27.484 -0.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2517",
    "data-name": "Trazado 2517",
    d: "M629.591,519.547h.9l1.3,2.838.763-2.838h.975l-1.2,4.45H631.5l-1.363-2.9-.787,2.9h-.963Z",
    transform: "translate(-31.845 -0.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2518",
    "data-name": "Trazado 2518",
    d: "M640.531,519.547h1.313a2.358,2.358,0,0,1,1.738.575,1.744,1.744,0,0,1,.487,1.3,2.441,2.441,0,0,1-.75,1.763,3.063,3.063,0,0,1-2.325.813h-1.65Zm.563,3.575a2.05,2.05,0,0,0,1.513-.55,1.6,1.6,0,0,0,.438-1.113.933.933,0,0,0-.263-.7,1.47,1.47,0,0,0-1.025-.325h-.487l-.725,2.688Z",
    transform: "translate(-36.258 -0.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2519",
    "data-name": "Trazado 2519",
    d: "M651.4,519.547h3.313l-.225.888h-2.35l-.25.888h2.063l-.225.863H651.65l-.25.963h2.4l-.237.85h-3.375Z",
    transform: "translate(-40.617 -0.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2520",
    "data-name": "Trazado 2520",
    d: "M667.425,522.247l-.925-2.7h1.075l.525,1.863,1.55-1.863h1.175l-2.45,2.8-.45,1.65h-.975Z",
    transform: "translate(-47.168 -0.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2521",
    "data-name": "Trazado 2521",
    d: "M681.406,522.113a2.738,2.738,0,0,1,2.725-2.675,2,2,0,0,1,1.8.95l-.825.575a1.241,1.241,0,0,0-1.1-.625,1.691,1.691,0,0,0-1.575,1.738,1.03,1.03,0,0,0,1.075,1.075,1.665,1.665,0,0,0,1.075-.45l.625.663a2.344,2.344,0,0,1-1.7.675A1.907,1.907,0,0,1,681.406,522.113Z",
    transform: "translate(-53.153 -0.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2522",
    "data-name": "Trazado 2522",
    d: "M691.688,522.572a2.6,2.6,0,0,1,.125-.712l.625-2.313h.975l-.65,2.4a2.818,2.818,0,0,0-.075.5.706.706,0,0,0,.775.738.925.925,0,0,0,.725-.3,1.689,1.689,0,0,0,.45-.812l.675-2.525h.975l-.7,2.663a2.8,2.8,0,0,1-.7,1.325,1.967,1.967,0,0,1-1.525.55A1.473,1.473,0,0,1,691.688,522.572Z",
    transform: "translate(-57.282 -0.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2523",
    "data-name": "Trazado 2523",
    d: "M703.819,519.5h.975l.7,4.488h-1.025l-.125-.987h-1.9l-.675.987h-1.05Zm.4,2.638-.2-1.488-1,1.488Z",
    transform: "translate(-60.922 -0.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2524",
    "data-name": "Trazado 2524",
    d: "M713.363,519.547h.9l1.325,2.838.75-2.838h.975L716.138,524h-.85l-1.35-2.9-.8,2.9h-.95Z",
    transform: "translate(-65.545 -0.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2525",
    "data-name": "Trazado 2525",
    d: "M724.3,519.547h1.325a2.3,2.3,0,0,1,1.725.575,1.661,1.661,0,0,1,.5,1.3,2.467,2.467,0,0,1-.725,1.763,3.123,3.123,0,0,1-2.35.813h-1.65Zm.6,3.575a2,2,0,0,0,1.475-.55,1.46,1.46,0,0,0,.45-1.113.941.941,0,0,0-.275-.7,1.377,1.377,0,0,0-1-.325h-.5l-.725,2.688Z",
    transform: "translate(-69.939 -0.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2526",
    "data-name": "Trazado 2526",
    d: "M734.563,522.075a2.653,2.653,0,0,1,2.675-2.638,1.938,1.938,0,0,1,2.05,1.975,2.673,2.673,0,0,1-2.7,2.625A1.907,1.907,0,0,1,734.563,522.075Zm3.725-.612a1.071,1.071,0,0,0-1.175-1.125,1.636,1.636,0,0,0-1.525,1.675,1.053,1.053,0,0,0,1.125,1.138A1.672,1.672,0,0,0,738.288,521.463Z",
    transform: "translate(-74.54 -0.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2527",
    "data-name": "Trazado 2527",
    d: "M754.975,523.788a2.787,2.787,0,0,1-1.175.25,1.928,1.928,0,0,1-2.05-1.963,2.675,2.675,0,0,1,2.7-2.638,1.917,1.917,0,0,1,2.025,1.975,2.638,2.638,0,0,1-.75,1.825l.375.475-.825.55Zm-.5-.763-.575-.775.8-.538.475.725a1.94,1.94,0,0,0,.3-.975,1.063,1.063,0,0,0-1.15-1.125,1.658,1.658,0,0,0-1.55,1.675,1.06,1.06,0,0,0,1.15,1.138A1.272,1.272,0,0,0,754.475,523.025Z",
    transform: "translate(-81.454 -0.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2528",
    "data-name": "Trazado 2528",
    d: "M763.313,522.572a3.892,3.892,0,0,1,.1-.712l.625-2.313h.975l-.65,2.4a2.938,2.938,0,0,0-.05.5.706.706,0,0,0,.775.738.962.962,0,0,0,.725-.3,1.67,1.67,0,0,0,.425-.812l.7-2.525h.975l-.725,2.663a2.8,2.8,0,0,1-.7,1.325,1.967,1.967,0,0,1-1.525.55A1.465,1.465,0,0,1,763.313,522.572Z",
    transform: "translate(-86.092 -0.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2529",
    "data-name": "Trazado 2529",
    d: "M774.575,519.547h.975L774.375,524h-1Z",
    transform: "translate(-90.148 -0.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2530",
    "data-name": "Trazado 2530",
    d: "M780.638,519.547h3.35l-.25.888h-2.35l-.25.888h2.05l-.225.863h-2.075l-.25.963h2.4l-.225.85h-3.375Z",
    transform: "translate(-92.583 -0.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2531",
    "data-name": "Trazado 2531",
    d: "M790.269,519.547h1.625a1.86,1.86,0,0,1,1.425.45,1.2,1.2,0,0,1,.35.9,1.393,1.393,0,0,1-.425,1.05,1.834,1.834,0,0,1-1.025.538l.75,1.513h-1.1l-.7-1.425h-.725L790.069,524h-.975Zm1.275,2.175a1.184,1.184,0,0,0,.9-.3.567.567,0,0,0,.2-.45.454.454,0,0,0-.15-.35.982.982,0,0,0-.65-.187h-.825l-.325,1.288Z",
    transform: "translate(-96.467 -0.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2532",
    "data-name": "Trazado 2532",
    d: "M801.656,519.5h.95l.7,4.488h-1.025l-.125-.987h-1.9l-.65.987h-1.075Zm.375,2.638-.2-1.488-.975,1.488Z",
    transform: "translate(-100.245 -0.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2533",
    "data-name": "Trazado 2533",
    d: "M809.656,523.213l.725-.625a1.576,1.576,0,0,0,1.25.588c.4,0,.7-.175.7-.475,0-.212-.175-.325-.775-.587-.575-.238-1.1-.538-1.1-1.213a1.585,1.585,0,0,1,1.775-1.463,2.2,2.2,0,0,1,1.675.663l-.675.688a1.485,1.485,0,0,0-1.075-.487c-.425,0-.65.237-.65.45,0,.238.175.35.775.588.625.25,1.075.563,1.075,1.213a1.6,1.6,0,0,1-1.775,1.475A2.287,2.287,0,0,1,809.656,523.213Z",
    transform: "translate(-104.724 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSlogan);
export default __webpack_public_path__ + "static/media/logo-slogan.68afa8fecf6ace515a36ee9f621457bf.svg";
export { ForwardRef as ReactComponent };